import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "./ui/alert-dialog";
import { useLang } from "../contexts/LanguageContext";

export default function ConfirmDeleteDialog({ open, onOpenChange, count, busy, onConfirm }) {
  const { t } = useLang();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="rounded-none border-zinc-800 bg-[#2B333B] text-zinc-100" data-testid="dup-confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-serif text-2xl font-light">
            {t("dup_confirm_title", count)}
          </AlertDialogTitle>
          <AlertDialogDescription className="text-zinc-400 font-light">{t("dup_confirm_body")}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <button
            onClick={() => onOpenChange(false)}
            className="border border-zinc-700 px-5 py-2 text-sm font-light text-zinc-300 hover:bg-zinc-900 transition-colors"
            data-testid="dup-confirm-cancel"
          >
            {t("dup_cancel")}
          </button>
          <button
            onClick={onConfirm}
            disabled={busy}
            className="bg-sienna text-white px-5 py-2 text-sm font-light hover:bg-sienna-400 disabled:opacity-60 transition-colors"
            data-testid="dup-confirm-delete"
          >
            {busy ? t("loading") : t("dup_delete_selected", count)}
          </button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
